import { request } from '@/utils'

export default {
  getSelectUser: (data: any) => request.post('/system/system/open/getSelectUser', data),
  totalStatistics: (data: any) => request.post('/data/purchase/apply/totalStatistics', data),
  pageList: (data: any) => request.post('/data/purchase/apply/pageList', data),
}
